/**
 * Número de pedido visible para el cliente (numero_operativo).
 * Nunca devuelve el UUID interno.
 *
 * @param {{ numeroOperativo?: number|null, codigoPedido?: string|null, pedidoId?: string|null }|null|undefined} pedido
 * @returns {string|null}
 */
export function numeroPedidoVisible(pedido) {
  if (!pedido) {
    return null;
  }
  if (pedido.numeroOperativo != null && Number(pedido.numeroOperativo) > 0) {
    return String(pedido.numeroOperativo);
  }
  const codigo = pedido.codigoPedido != null ? String(pedido.codigoPedido).trim() : "";
  if (
    codigo &&
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(codigo)
  ) {
    return codigo;
  }
  return null;
}

/**
 * @param {string|null|undefined} canal
 * @returns {string|null}
 */
export function etiquetaCanal(canal) {
  if (!canal) return null;
  if (canal === "delivery") return "Delivery";
  if (canal === "retiro") return "Retiro en local";
  if (canal === "mostrador") return "Mostrador";
  return canal;
}

/**
 * @param {string|null|undefined} estado
 * @returns {string|null}
 */
export function etiquetaEstado(estado) {
  if (!estado) return null;
  const mapa = {
    pendiente: "Pendiente",
    confirmado: "Confirmado",
    preparacion: "En preparación",
    listo: "Listo",
    entregado: "Entregado",
    cancelado: "Cancelado",
  };
  return mapa[estado] || estado;
}

/**
 * @param {number|null|undefined} monto
 * @returns {string|null}
 */
export function formatearMonto(monto) {
  if (monto == null || !Number.isFinite(Number(monto))) {
    return null;
  }
  return `$${Number(monto).toLocaleString("es-CL")}`;
}

/**
 * @param {string|null|undefined} iso
 * @returns {string|null}
 */
export function formatearFechaHora(iso) {
  if (!iso) return null;
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return null;
  return fecha.toLocaleString("es-CL", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}
